__turbopack_context__.v({
  "connector": "DleQha_connector",
  "connectorContainer": "DleQha_connectorContainer",
  "heading": "DleQha_heading",
  "headline": "DleQha_headline",
  "icon": "DleQha_icon",
  "orderStatus": "DleQha_orderStatus",
  "pill": "DleQha_pill",
  "step": "DleQha_step",
  "svgWrapper": "DleQha_svgWrapper",
  "text": "DleQha_text",
  "textContainer": "DleQha_textContainer",
});
